<template>
  <div>
    <card-header :title="`Dashboard`" />
    <section class="section is-main-section">
      <div
        class="tile is-ancestor"
        v-if="$util.hasAnyRole(['ROLE_VIGILANTE'])"
      >
        <DashboardCard
          :title="'Ativações'"
          :secondTitle="''"
          icon="mdi-boom-gate-up"
          route="ativacoes?page=1&orderBy=id,DESC"
          color="#000957"
        />
        <DashboardCard
          :title="'Consultar'"
          :secondTitle="'Placa'"
          icon="mdi-search-web"
          route="ConsultarPlaca"
          color="#344CB7"
        />
      </div>
      <div
        class="tile is-ancestor"
        v-if="!$util.hasAnyRole(['ROLE_AREASECUNDARIA']) && !$util.hasAnyRole(['ROLE_VIGILANTE'])"
      >
        <DashboardCard
          :title="'Pessoas'"
          :secondTitle="'Pendentes'"
          icon="mdi-account-tie"
          route="acessos/pessoas?status=PENDENTE"
          :value="infoCards.pessoaPendente"
          color="#000957"
        />
        <DashboardCard
          :title="'Pendentes'"
          :secondTitle="'de Biometria'"
          icon="mdi-account-tie"
          route="acessos/pessoas?status=PENDENTE_BIOMETRIA"
          :value="infoCards.pessoaPendenteBiometria"
          color="#344CB7"
        />
        <DashboardCard
          :title="'Documentação'"
          :secondTitle="'Expirada'"
          icon="mdi-account-tie"
          route="acessos/pessoas?status=DOCUMENTACAO_EXPIRADA"
          :value="infoCards.pessoaDocumentacaoExpirada"
          color="#344CB7"
        />
        <DashboardCard
          :title="'Pessoas'"
          :secondTitle="'Recusadas'"
          icon="mdi-account-tie"
          route="acessos/pessoas?status=RECUSADO"
          :value="infoCards.pessoaRecusado"
          color="#345eb3"
        />
      </div>
      <div class="tile is-ancestor" v-if="!$util.hasAnyRole(['ROLE_VIGILANTE'])">
        <DashboardCard
          :title="'Veiculos'"
          :secondTitle="'Pendentes'"
          icon="mdi-car-back"
          route="acessos/veiculos?status=PENDENTE"
          :value="infoCards.veiculoPendente"
          color="#000957"
        />
        <DashboardCard
          :title="'Veiculos'"
          :secondTitle="'Ativos'"
          icon="mdi-car-back"
          route="acessos/veiculos?status=ATIVO"
          :value="infoCards.veiculoAtivo"
          color="#344CB7"
        />
        <DashboardCard
          :title="'Veiculos'"
          :secondTitle="'Inativos'"
          icon="mdi-car-back"
          route="acessos/veiculos?status=INATIVO"
          :value="infoCards.veiculoInativo"
          color="#344CB7"
        />
        <DashboardCard
          :title="'Veiculos'"
          :secondTitle="'Recusados'"
          icon="mdi-car-back"
          route="acessos/veiculos?status=RECUSADO"
          :value="infoCards.veiculoRecusado"
          color="#345eb3"
        />
      </div>
      <div class="tile is-ancestor" v-if="$util.hasAnyRole(['ROLE_ADMIN'])">
        <DashboardCard
          :title="'Empresas'"
          :secondTitle="'Pendentes'"
          icon="mdi-domain"
          route="externos?status=PENDENTE"
          :value="infoCards.empresaPendente"
          color="#000957"
        />
      </div>
      <br />
    </section>
  </div>
</template>

<style></style>

<script>
import { defineComponent } from "vue";

import * as chartConfig from "@/components/Charts/chart.config.js";
import TitleBar from "@/components/TitleBar.vue";
import HeroBar from "@/components/HeroBar.vue";
import TilesBlock from "@/components/TilesBlock.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import LineChart from "@/components/Charts/LineChart.vue";
import DashboardCard from "@/components/Cards/Card.vue";
import CardHeader from "@/components/Cards/CardHeader.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    LineChart,
    CardComponent,
    TilesBlock,
    HeroBar,
    TitleBar,
    DashboardCard,
    CardHeader,
  },
  data() {
    return {
      secondTitleStack: ["SECAPI", "Dashboard"],
      chartData: null,
      teste: null,
      infoCards: [],
    };
  },
  mounted() {
    this.$http.get("/dashboard").then((response) => {
      this.infoCards = response.data;
      console.log(this.infoCards);
    });

    this.fillChartData();
  },
  methods: {
    fillChartData() {
      this.chartData = chartConfig.sampleChartData();
    },
  },
});
</script>
